module.exports = __webpack_public_path__ + "static/903-83385cb4074a3d153ead73b1656f3e7a.png";